// Piattaforme pubblicitarie (features/ads nel backend): nome, logo ufficiale, colore nei grafici, console

export const SOURCES = {
	google: {
		label: 'Google Ads',
		logo: require('@/assets/images/seo/google-ads.png'),
		color: '#1A73E8',
		console: () => 'https://ads.google.com/aw/campaigns',
	},
	meta: { label: 'Meta', logo: require('@/assets/images/social/meta.png'), color: '#0866FF', console: () => 'https://adsmanager.facebook.com/' },
	tiktok: { label: 'TikTok Ads', logo: require('@/assets/images/social/tiktok.svg'), color: '#111111', console: () => 'https://ads.tiktok.com/' },
	microsoft: { label: 'Microsoft Ads', logo: require('@/assets/images/microsoft.svg'), color: '#00A4EF', console: () => 'https://ui.ads.microsoft.com/' },
};

export const sourceInfo = key => SOURCES[key] || { label: key, logo: '', color: '#9E9E9E', console: () => '' };

// "ROAS 3,4" o "—"
export const formatRoas = v => (v === null || v === undefined ? '—' : `${String(Math.round(v * 100) / 100).replace('.', ',')}`);

// stato della campagna come lo restituisce la piattaforma
export const CAMPAIGN_STATUS = {
	ENABLED: { label: 'Attiva', color: 'green darken-1' },
	PAUSED: { label: 'In pausa', color: 'grey darken-1' },
	REMOVED: { label: 'Rimossa', color: 'grey' },
};
